import { useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'

export const winnersExportQueryKey = ['/admin/exports/winners/{contestId}']

export const useGetExportForWinnersByContestId = ({
  contestId,
  enabled = true,
}: {
  contestId: number
  enabled?: boolean
}) => {
  const get = useTypedApiClient({
    path: '/admin/exports/winners/{contestId}',
    method: 'get',
  })
  return useQuery({
    queryKey: [...winnersExportQueryKey, contestId],
    enabled,
    staleTime: 0,
    queryFn: async () => {
      const { data } = await get({ contestId })
      return data
    },
  })
}
